import { render, staticRenderFns } from "./WelfareSetMealDetails.vue?vue&type=template&id=79e9aafb&scoped=true"
import script from "./WelfareSetMealDetails.vue?vue&type=script&lang=js"
export * from "./WelfareSetMealDetails.vue?vue&type=script&lang=js"
import style0 from "./WelfareSetMealDetails.vue?vue&type=style&index=0&id=79e9aafb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e9aafb",
  null
  
)

export default component.exports